// @ts-strict-ignore
import Link from 'next/link'
import { useMemo, useState } from 'react'

import { createMarkup } from '@/shared/lib/utils/common/createMarkup'
import { Button } from '@/shared/ui'
import { Col, Row } from '@/shared/ui/Grid'
import { Text } from '@/shared/ui/Typography'

import styles from './spec-item.module.scss'

export type TSpecItem = {
	name: string
	value?: string
	values: { NAME: string; LINK?: string }[]
	link?: string
}

const VISIBLES_ITEMS_COUNT = 5

export const SpecItem = ({ name, values }: TSpecItem): JSX.Element => {
	const [isExpanded, setIsExpanded] = useState(false)

	const hasMoreValues = values.length > VISIBLES_ITEMS_COUNT
	const visibleValues = useMemo(
		() => (isExpanded ? values : values.slice(0, VISIBLES_ITEMS_COUNT)),
		[isExpanded, values]
	)

	const toggleExpand = () => setIsExpanded(!isExpanded)

	return (
		<div className={styles.specItem}>
			<Row>
				<Col xs={17} lg={14}>
					<Text>
						{name}:{` `}
					</Text>
				</Col>
				<Col xs={7} lg={10}>
					{visibleValues.map(item => {
						if (!item?.LINK) {
							return <dd key={item.NAME} className={styles.value} dangerouslySetInnerHTML={createMarkup(item?.NAME)} />
						}
						if (item?.LINK) {
							return (
								<dd key={item.NAME} className={styles.value}>
									<Link prefetch={false} href={item.LINK} target="_blank">
										{item?.NAME}
									</Link>
								</dd>
							)
						}
					})}
					{hasMoreValues && (
						<Button theme="link" onClick={toggleExpand} style={{ marginTop: '10px' }}>
							{isExpanded ? `Скрыть` : `Показать все`}
						</Button>
					)}
				</Col>
			</Row>
		</div>
	)
}
